export default __webpack_public_path__ + "static/media/android.9c7ff328.svg";